import React, { useState, useEffect, FormEvent } from "react";
import {
  LdLabel,
  LdSelect,
  LdIcon,
  LdOption,
  LdInput,
  LdButton,
} from "@emdgroup-liquid/liquid/dist/react";

interface Props {
  tags: string[];
  label?: string | null;
  icon?: string | boolean | JSX.Element;
  placeholder?: string;
  onChange: (arg0: string[]) => void;
}

const TagInput = React.forwardRef<HTMLFormElement, Props>(
  (
    { placeholder, tags: initialTags, label = null, icon = "add", onChange },
    ref
  ) => {
    const [tags, setTags] = useState(initialTags);
    const [text, setText] = useState<string>();

    useEffect(() => {
      onChange(tags);
    }, [tags, onChange]);

    const handleAddTag = (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      if (text !== undefined) setTags((state) => [...state, text]);
      setText(undefined);
    };

    const renderIcon = () => {
      if (icon === false) {
        return null;
      }
      return (
        <LdButton mode="ghost" slot="end" aria-label="Submit" type="submit">
          {typeof icon === "string" ? <LdIcon name={icon} /> : icon}
        </LdButton>
      );
    };

    return (
      <form
        ref={ref}
        onSubmit={handleAddTag}
        className="flex flex-col gap-ld-32"
      >
        <LdLabel>
          {label}
          {tags.length > 0 && (
            <LdSelect
              name="options"
              onClick={(e) => e.preventDefault()}
              className="question-options"
              popperClass="question-options-popper"
              multiple
              onInput={
                ((
                  event: React.SyntheticEvent<
                    HTMLInputElement,
                    CustomEvent<string[]>
                  >
                ) => {
                  setTags(event.nativeEvent.detail);
                }) as unknown as any
              }
            >
              {tags.map((tag) => (
                <LdOption key={tag} value={tag} selected>
                  {tag}
                </LdOption>
              ))}
              <LdIcon name="" />
            </LdSelect>
          )}
        </LdLabel>
        <LdInput
          value={text}
          placeholder={placeholder}
          onInput={(ev) => {
            setText((ev.target as HTMLLdInputElement).value);
          }}
        >
          {renderIcon()}
        </LdInput>
      </form>
    );
  }
);

export default TagInput;
